<script>
export default {
  name: "MdiViewDashboard",
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: "#8E8E8E",
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13,3V9H21V3"
      :fill="color"
    />
    <path
      d="M13,21H21V11H13"
      :fill="color"
    />
    <path
      d="M3,21H11V15H3"
      :fill="color"
    />
    <path
      d="M3,13H11V3H3V13Z"
      :fill="color"
    />
  </svg>
</template>
